/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import {object, string, number} from 'yup'

export const fleetModel = (intl) => {
    return object().shape({
        name: string()
            .required(intl.formatMessage({id: "fleet.schema.name.required"}))
            .trim().min(3, intl.formatMessage({id: "fleet.schema.name.minSize"}))
            .trim().max(60, intl.formatMessage({id: "fleet.schema.name.maxSize"})),
        parentId: number()
            .nullable()
            .required(intl.formatMessage({id: "fleet.schema.parentId.required"})),
    })
}


